import Spinner from "../Spinner/Spinner";
import "./styles.scss";



function AppLoader() {
  return (
    <div className="app-loader">
      <Spinner />
    </div>
  );
}

export default AppLoader;